import { getTasksToken } from "./tokenService"
import azureGatewayService from "./azureGatewayService"

const { get } = azureGatewayService(getTasksToken);

/**
 * @returns {Promise<OfficeDropDownDto[]>}
 */
export const getOfficeFilters = async () => await get(`/Filters`)
